import { z } from 'zod/v4';

export const accountVehicleGroupSchema = z.object({
  vehicleGroupId: z.number(),
  vehicleGroupName: z.string(),
});

export type AccountVehicleGroup = z.infer<typeof accountVehicleGroupSchema>;

export const accountVehicleGroupsSchema = z.array(accountVehicleGroupSchema);

export type AccountVehicleGroups = z.infer<typeof accountVehicleGroupsSchema>;
